import { useEffect, useState } from 'react'
import { CustomCellEditorProps } from 'ag-grid-react'
import { StatusComboBox } from '../../../components/comboBox/StatusComboBox'

export const LinkedStatusCellEditor = ({
  value,
  api,
  context,
  onValueChange,
}: CustomCellEditorProps) => {
  const statusOptions = context.statusOptions ?? []
  // 選択が行われたら(開く前と同じ値を選び直した場合も含めて)確定して編集を終了する。
  // 「値が変わったとき」を条件にすると、同じステータスを選び直したときに編集が終わらず
  // セルが編集モードのまま固まってキーボード操作を受け付けなくなる。
  const [selectedValue, setSelectedValue] = useState<string | null>(null)

  useEffect(() => {
    if (selectedValue === null) return
    onValueChange(selectedValue)
    api.stopEditing()
  }, [selectedValue, api, onValueChange])

  return (
    <StatusComboBox
      value={selectedValue ?? value ?? ''}
      options={statusOptions}
      dropDownListOpen={true}
      onChange={newValue => setSelectedValue(newValue)}
      onClick={() => {
        api.stopEditing()
      }}
    />
  )
}
